var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#2583FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8686 36.52H36.1314V49H44.3941C44.942 49 45.4674 48.7809 45.8548 48.3908C46.2422 48.0007 46.4598 47.4716 46.4598 46.92V32.36H49.9653C50.1744 32.3604 50.3788 32.2968 50.5513 32.1777C50.7238 32.0586 50.8563 31.8896 50.9313 31.693C51.0063 31.4964 51.0203 31.2815 50.9713 31.0767C50.9224 30.8719 50.8129 30.687 50.6573 30.5462L32.6899 14.2661C32.5004 14.0948 32.2547 14 32 14C31.7453 14 31.4996 14.0948 31.3101 14.2661L13.3427 30.5462C13.1871 30.687 13.0776 30.8719 13.0287 31.0767C12.9797 31.2815 12.9937 31.4964 13.0687 31.693C13.1437 31.8896 13.2762 32.0586 13.4487 32.1777C13.6212 32.2968 13.8256 32.3604 14.0347 32.36H17.5402V46.92C17.5402 47.4716 17.7578 48.0007 18.1452 48.3908C18.5326 48.7809 19.058 49 19.6059 49H27.8686V36.52Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.137274795c2499840268f1c2e077c562.svg";
export { ForwardRef as ReactComponent };